import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { translate, TranslocoPipe } from '@jsverse/transloco';
import { DialogComponent } from 'vcp-common-ui-lib';

@Component({
    selector: 'vc-delete-confirmation-dialog',
    templateUrl: './delete-confirmation-dialog.component.html',
    styleUrls: ['./delete-confirmation-dialog.component.scss'],
    imports: [TranslocoPipe, DialogComponent],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DeleteConfirmationDialogComponent {
    @Input()
    dialogTitle!: string;

    @Input()
    dialogMessage!: string;

    @Input()
    primaryLabel: string = translate('COMMON_UI.DELETE');

    @Input()
    set visible(value: boolean) {
        if (this._visible != value) {
            this._visible = value;
            this.visibleChange.emit(this._visible);
        }
    }
    get visible(): boolean {
        return this._visible;
    }

    private _visible: boolean = false;

    @Output()
    visibleChange = new EventEmitter<boolean>();

    @Output()
    confirmDelete = new EventEmitter<void>();

    onDelete(): void {
        this.confirmDelete.emit();
        this.visible = false;
    }
}
